export { default } from './setCookie'
